import {RegulatoryDataSiBox} from "./regulatory-data.si.box";

export const RegulatoryDataSiCisBox = RegulatoryDataSiBox;